import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';
import { getRequest, postRequest, postFileUploadRequest, HandlerResponse } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetRunRatePlanData = async (queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return getRequest(`${Environment.API}/run-rate-plan/show-grid${queryString}`)
        .then((resp: any) => HandlerResponse(resp));
};

export interface IMeasureVisibilityPayload {
    visibility: {
        key: string;
        isVisible: boolean;
    }[];
}

export const UpdateRunRatePlanMeasureVisibility = async (payload: IMeasureVisibilityPayload, queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/saveMeasureVisibility${queryString}`, payload)
        .then((resp: any) => HandlerResponse(resp));
};

export interface IMeasureSequencePayload {
    key: string;
    sequence: number;
    width: number;
}

export const SaveRunRatePlanMeasureSequenceAndWidth = async (payload: IMeasureSequencePayload[], queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/saveMeasureSequenceAndWidth${queryString}`, payload)
        .then((resp: any) => HandlerResponse(resp));
};

export interface ISaveAndFreezePayload {
    sku: string;
    quarters: {
        name: string;
        key: string;
        weeks: {
            name: string;
            value: number;
            salesValue: number;
            planAsp: number;
            planMargin: number;
        }[];
    }[];
}

export const SaveAndFreezePlan = async (payload: ISaveAndFreezePayload[], queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/save/plan${queryString}`, payload)
        .then((resp: any) => HandlerResponse(resp));
};

export interface ISkuSequencePayload {
    key: string;
    sequence: number;
}

export const SaveRunRatePlanSkuSequence = async (payload: ISkuSequencePayload[], queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/save-sku-sequence${queryString}`, payload)
        .then((resp: any) => HandlerResponse(resp));
};

export const ExportWeightMeasure = async (queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return getRequest(`${Environment.API}/run-rate-plan/export-weight-measure${queryString}`)
        .then((resp: any) => resp);
};

export const ImportWeightMeasure = async (file: any, queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postFileUploadRequest(`${Environment.API}/run-rate-plan/import-weight-measure${queryString}`, file)
        .then((resp: any) => HandlerResponse(resp));
};

export interface IExportPlanRRPayload {
    sku: string;
    historicalRR: number;
    planRR: number;
    weeks: {
        name: string;
        value: number;
    }[];
}

export const ExportPlanRR = async (payload: IExportPlanRRPayload[], queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/export-plan-rr${queryString}`, payload)
        .then((resp: any) => resp);
};

export const ImportPlanRR = async (file: any, queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postFileUploadRequest(`${Environment.API}/run-rate-plan/import-plan-rr${queryString}`, file)
        .then((resp: any) => HandlerResponse(resp));
};

export interface INPICopyPredecessorPayload {
    predecessorSku: string;
    sku: string;
    quarters: {
        name: string;
        key: string;
        weeks: {
            name: string;
            value: number;
        }[];
    }[];
}

export const NPICopyPredecessorSku = async (payload: INPICopyPredecessorPayload, queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/npi-copy-predecessor-sku${queryString}`, payload)
        .then((resp: any) => HandlerResponse(resp));
};

export const SaveHistoricSelection = async (queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return postRequest(`${Environment.API}/run-rate-plan/save-historic-selection${queryString}`)
        .then((resp: any) => HandlerResponse(resp));
};

export const GetHistoricSelection = async (queryParams?: any) => {
    genearteNewToken();
    const queryString = ObjToQueryString(queryParams);
    return getRequest(`${Environment.API}/run-rate-plan/get-historic-selection${queryString}`)
        .then((resp: any) => HandlerResponse(resp));
};
